module.exports = __webpack_public_path__ + "static/media/ps.0debffbc.webp";